import useDelayedLoadOptions, {
    DelayedLoadOptions,
} from 'app/hooks/useDelayedLoadOptions'
import {
    LaneStatus,
} from 'app/enums/label.enums'

import requestConfig from 'app/requests/Lane/Lane.requests'

const useLaneRequest = (): { loadOptions: (options: DelayedLoadOptions) => Promise<any> } => {
    const loadOptions = useDelayedLoadOptions({
        url: requestConfig.selector({}).url,
        includeFilters: {
            laneStatus: [LaneStatus.IMPLEMENTED],
        },
    })

    return {
        loadOptions,
    }
}

export default useLaneRequest
